import {useNavigate, useParams, Link} from "react-router-dom";
import {useForm} from "react-hook-form";
import React, {useState, useEffect, useContext, forwardRef} from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  HStack,
  VStack,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input, Divider,
  Textarea, Alert, AlertIcon, AlertTitle, Select,
  Checkbox,
  InputProps,
  Text,
  useDisclosure,
  Container,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter,
} from '@chakra-ui/react';
import ReactPaginate from "react-paginate";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {client} from "@/client"
import {GlobalContext, bearerToken, emptyUser} from "@/auth";
import {User} from "@/pbgen/v1/main_pb"
import {
  Page,
  PageHeader,
  PageBody,
} from "@/components/layout"

import './ListForm.css';

function teacherStatus(status: string): string {
  switch (status) {
    case "sabbatical": return "休職";
    case "teaching": return "勤務";
    default: return "不明";
  }
}

export const Teachers = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [vendors, setVendors] = useState<User[]>([]);
  const itemsPerPage = 10;
  const pageCount = Math.ceil(users.length / itemsPerPage);
  const [itemsOffset, setItemsOffset] = useState(0);
  const endOffset = itemsOffset + itemsPerPage
  const currentUsers = users.slice(itemsOffset, endOffset);
  const {globalState, setGlobalState} = useContext(GlobalContext);
  const navigate = useNavigate();
  const { vid } = useParams();
  const [currentRole, setCurrentRole] = useState<string | undefined>(undefined)

  useEffect(() => {
    (async () => {
      if (! vid) {
        const resp = await client.getVendors({
          bearerToken: bearerToken(),
        });
        if (!resp.currentUser) {
          navigate("/login", {relative: "path"});
          return;
        }
        if (resp.vendors.length === 0) {
          navigate("/manage", {relative: "path"});
          return
        }
        const newVid = resp.vendors[0].id;
        navigate(`../vendors/${newVid}/teachers`, {relative: "path", replace: true});
        return
      }
      const resp = await client.getTeachers({
        bearerToken: bearerToken(),
        optVendorId: vid,
      });
      setGlobalState({...globalState, currentUser: resp.currentUser ?? emptyUser()})
      if (! resp.currentUser) {
        navigate("/login", { relative: "path" });
        return;
      }
      setCurrentRole(resp.currentUser.optRole);
      setUsers(resp.teachers);
      if (resp.currentUser.optRole === "admin") {
        const resp = await client.getVendors({
          bearerToken: bearerToken(),
        });
        setVendors(resp.vendors);
      } else {
        const resp = await client.getUser({
          bearerToken: bearerToken(),
          id: vid,
        })
        if (! resp.user) {
          navigate("/manage", {relative: "path"});
          return
        }
        setVendors([resp.user])
      }
    })();
  }, [vid]) // eslint-disable-line react-hooks/exhaustive-deps

  const handlePageClick = (e: { selected: number }) => {
    const newOffset = (e.selected * itemsPerPage);
    setItemsOffset(newOffset);
  }

  const getDatetimeElement = (date: Date): JSX.Element => {

    return (
      <>
      <p>
      {
        (date.getFullYear() + "年" +
        (date.getMonth() + 1).toString().padStart(2, '0') + "月" +
        date.getDate().toString().padStart(2, '0') + "日")
      }
      </p>
      <p>
      {
        [ date.getHours().toString().padStart(2, '0'),
          date.getMinutes().toString().padStart(2, '0'),
          date.getSeconds().toString().padStart(2, '0')
        ].join(':')
      }
      </p>
      </>
    );
  }

  return <Page>
    <PageHeader title={"先生一覧"}>
      <HStack padding={2}>

        {(currentRole === "admin") ? 
          <Select placeholder="事業者を選択" value={vid} onChange={(e) => navigate(`../../${e.target.value}/teachers`, {relative: "path", replace: true})}>
            {
            vendors.map((vendor) =>
              <option key={vendor.id} value={vendor.id}>{vendor.optName ?? ""}</option>
            )
          }
          </Select>
        : null }

        <Button px={9} onClick={() => {navigate("./new", { relative: "path" })}}>先生新規登録</Button>

        {/* <Button onClick={() => {navigate("../..", { relative: "path" })}}>戻る</Button> */}
        {/*<Button isDisabled={window.history.length <= 2} onClick={() => {navigate(-1)}}>メニューに戻る</Button>*/}
        <Button px={9} as={Link} to="/manage">メニューに戻る</Button>

      </HStack>
    </PageHeader>

    <PageBody>
      <VStack>
        <Table className="list_table">
          <Thead>
            <Tr>
              <Th width={'10em'}>ID</Th>
              <Th>氏名</Th>
              <Th width={'10em'}>ステータス</Th>
              <Th width={'10em'}>最終ログイン日時</Th>
              <Th width={'10em'}>編集</Th>
            </Tr>
          </Thead>
          <Tbody>
          {
            currentUsers.map((user) => <Tr key={user.id}>
              <Td>{user.id}</Td>

              <Td>
                <VStack align="start">
                {
                  (!!user.optFamilyName || !!user.optName) ? (
                    <>
                    <p>
                    {
                    (!!user.optFamilyName) ? (
                      <span className="list_table_name" >{user.optFamilyName ?? ""}　</span>
                      ) : null
                    }
                    {
                    (!!user.optName) ? (
                      <span className="list_table_name">{user.optName ?? ""}</span>
                      ) : null
                    }
                    </p>
                    </>
                  ) : null
                }
                {
                  (!!user.optFamilyNamePronunciation || !!user.optNamePronunciation) ? (
                    <>
                    <p>
                    {
                    (!!user.optFamilyNamePronunciation) ? (
                      <span>{user.optFamilyNamePronunciation ?? ""}　</span>
                      ) : null
                    }
                    {
                    (!!user.optNamePronunciation) ? (
                      <span>{user.optNamePronunciation ?? ""}</span>
                      ) : null
                    }
                    </p>
                    </>
                  ) : null
                }
                </VStack>              
              </Td>

              <Td>{user.optStatus ? teacherStatus(user.optStatus) : "—"}</Td>

              <Td>{user.optLastLoginAtRfc3339 ? getDatetimeElement(new Date(user.optLastLoginAtRfc3339)) : "—"}</Td>

              <Td><Button onClick={() => {navigate(`./${user.id}`, { relative: "path" })}}>編集</Button></Td>
            </Tr>)
          }
          {
            [...Array(itemsPerPage - currentUsers.length)].map((_, i) => (
              <Tr key={`dummy-${i}`}>
                <Td>—</Td>
                <Td>—</Td>
                <Td>—</Td>
                <Td>—</Td>
                <Td>—</Td>
              </Tr>)
            )
          }
          </Tbody>
        </Table>
        {/*<ReactPaginate pageCount={pageCount} onClick={handlePageClick} />*/}
        <ReactPaginate 
          previousLabel="前へ"
          nextLabel="次へ"
          breakLabel="..."
          pageCount={pageCount} onPageChange={handlePageClick} className={'react-paginate'} />
      </VStack>
    </PageBody>
  </Page>
}


type FormData = {
  id: string;
  password: string;
  status: string;
  expiredate: Date;
  name: string;
  namePronunciation: string;
  familyName: string;
  familyNamePronunciation: string;
  postalNumber: string;
  address1: string;
  address2: string;
  phoneNumber: string;
  email: string;
  note: string;
};

export const Teacher = () => {
  const [formError, setFormError] = useState('');
  const [lastLoginAt, setLastLoginAt] = useState<string>('');
  const {
    register: registerElement,
    handleSubmit: wrapSubmitHandlerWithFormValidator,
    formState: { errors: formErrors },
    setValue,
  } = useForm<FormData>();
  const { globalState, setGlobalState } = useContext(GlobalContext);
  const navigate = useNavigate();
  const { vid, tid: id } = useParams();
  const [birthday, setBirthday] = useState<Date | null>(null);
  const [expirationDate, setExpirationDate] = useState<Date | null>(null);
  const { isOpen: isErrorOpen, onOpen: onErrorOpen, onClose: onErrorClose } = useDisclosure()
  const { isOpen: isDeleteOpen, onOpen: onDeleteOpen, onClose: onDeleteClose } = useDisclosure()
  const cancelDeleteRef = React.useRef<HTMLButtonElement | null>(null)
  const [showPassword, setShowPassword] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const { isOpen: isFinishOpen, onOpen: onFinishOpen, onClose: onFinishClose } = useDisclosure()

  useEffect(() => {
    (async () => {

      if (id === "new") {
        const resp = await client.getLastId({
          bearerToken: bearerToken(),
          vendorId: vid,
        });
        setValue("id", (parseInt(resp.lastId) + 1).toString().padStart(resp.lastId.length, "0"))
        return;
      }

      const resp = await client.getUser({
        bearerToken: bearerToken(),
        id,
      });
      setGlobalState({...globalState, currentUser: resp.currentUser ?? emptyUser()})
      if (! resp.currentUser) {
        navigate("/login", { relative: "path" });
        return;
      }
      if (! resp.user) {
        navigate("..", { relative: "path" });
        return;
      }

      setValue("id", resp.user.id);
      setValue("password", "");
      if (resp.user.optStatus) {
        setValue("status", resp.user.optStatus ?? "");
      }
      const x = resp.user.optExpires !== undefined ? resp.user.optExpires : false
      if (resp.user.optExpires) {
        setExpirationDate(new Date(resp.user.optExpiresAtRfc3339 ?? ""));
      }
      if (resp.user.optBirthday && resp.user.optBirthday !== "0000-00-00") {
        // Date.parse() の指定でタイムゾーンを指定しない場合、年月日のみの文字列は UTC になり、時分まで指定するとローカルタイムになる謎仕様。以下で、ローカルタイムの 00:00 になる
        setBirthday(new Date(resp.user.optBirthday + "T00:00:00"));
      }
      setValue("name", resp.user.optName ?? "");
      setValue("namePronunciation", resp.user.optNamePronunciation ?? "");
      setValue("familyName", resp.user.optFamilyName ?? "");
      setValue("familyNamePronunciation", resp.user.optFamilyNamePronunciation ?? "");
      setValue("note", resp.user.optNote ?? "");

      setValue("postalNumber", resp.user.optPostalNumber ?? "");
      setValue("address1", resp.user.optAddress1 ?? "");
      setValue("address2", resp.user.optAddress2 ?? "");
      setValue("phoneNumber", resp.user.optPhoneNumber ?? "");
      setValue("email", resp.user.optEmail ?? "");

      setLastLoginAt(resp.user.optLastLoginAtRfc3339 ?? "");

    })();
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  if (! id) {
    navigate("..", { relative: "path" });
    return <></>;
  }

  const handleStatusChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    //console.log("Selected Value on Change:", value);

    if (value === "sabbatical") {
      setExpirationDate(null);
    }
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible); // 表示状態を切り替える
  };

  const handleOk = () => {
    navigate(-1);
  };

  const submitIfValid = wrapSubmitHandlerWithFormValidator(async (data) => {
    //console.log(data)

    const user = new User({
      optVendorId: vid,
      optRole: "teacher",
      id: data.id,
      optPassword: data.password,
      optStatus: data.status,

      optName: data.name,
      optFamilyName: data.familyName,
      optNamePronunciation: data.namePronunciation,
      optFamilyNamePronunciation: data.familyNamePronunciation,
      optBirthday: birthday ? (date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`)(birthday) : "0000-00-00",

      optPostalNumber:  data.postalNumber,
      optAddress1:  data.address1,
      optAddress2:  data.address2,
      optPhoneNumber:  data.phoneNumber,
      optEmail:  data.email,

      optExpires: expirationDate != null,
      optExpiresAtRfc3339: expirationDate?.toISOString() ?? undefined,

      optNote: data.note,
    })
    console.log(user)

    const resp = await client.saveUser({
      bearerToken: bearerToken(),
      user: user,
      newUser: ("new" === id),
    });
    if (resp.error) {
      setFormError(resp.error.message);
      onErrorOpen();
      return;
    } else {
      onFinishOpen();
    }
    if (id === "new") {
      navigate(`../${data.id}`, {relative: "path", replace: true})
    }
  });
  return <Page>
    <PageHeader title={("new" === id)? "先生新規登録": "先生編集"}>
      <HStack padding={2}>
        <Button onClick={submitIfValid}>{("new" === id)? "登録": "保存"}</Button>
        {/* <Button onClick={() => {navigate("..", { relative: "path" })}}>戻る</Button> */}
        <Button isDisabled={window.history.length <= 2} onClick={() => {navigate(-1)}}>戻る</Button>
 
        <AlertDialog isOpen={isDeleteOpen} onClose={onDeleteClose} leastDestructiveRef={cancelDeleteRef}>
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader>
                先生の削除
              </AlertDialogHeader>
              <AlertDialogBody>
                先生「{id}」を本当に削除しますか？
              </AlertDialogBody>
              <AlertDialogFooter>
                <Button ref={cancelDeleteRef} onClick={onDeleteClose}>
                  キャンセル
                </Button>
                <Button  ml={3} onClick={async () => {
                    const resp = await client.deleteUser({
                    bearerToken: bearerToken(),
                    id,
                });
                if (resp.error) {
                  setFormError(resp.error.message);
                  onErrorOpen();
                  return;
                }
                navigate("..", { relative: "path", replace: true})
                }}>削除</Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>

        {("new" !== id) ? 
          <Button onClick={async () => {onDeleteOpen()}}>削除</Button>
        : null }
 
      </HStack>
    </PageHeader>

    <PageBody>
      <VStack className="edit_form" spacing={4} align="start">

        <HStack>
          <FormControl isInvalid={Boolean(formErrors.id)}>
            <FormLabel><span>ID</span></FormLabel>
            <Input className="edit_form_short" disabled autoComplete={"off"} {...registerElement("id", {})} />
{/*
          <Input isDisabled={("new" !== id)} autoComplete={"off"} {...registerElement("id", {})} />
          <FormErrorMessage>{ formErrors.id?.message }</FormErrorMessage>
*/}
          </FormControl>
        </HStack>

        <HStack>
        {
          ("new" === id) ? (
            <>
            <VStack align="flex-start">
              <FormControl isInvalid={Boolean(formErrors.password)} isRequired>
                <FormLabel 
                  requiredIndicator = {
                    <span style={{ color: "white", fontSize: "70%", backgroundColor:"#df6694", marginLeft: "4px",}}>✱必須項目</span>
                  }>
                  <span>パスワード</span>
                </FormLabel>
                <Input
                  className="edit_form_middle"
                  type={showPassword ? "text" : "password"} 
                  placeholder=""
                  autoComplete={"new-password"}
                  {...registerElement("password", 
                    {
                      required: "パスワードは必須項目です。",
                      pattern: {
                        value: /^(?=.*\d).{8,}$/,
                        message: "パスワードは数字を含む8文字以上の半角文字を設定してください。",
                      },
                    }
                  )} />
                  <FormErrorMessage>{ formErrors.password?.message }</FormErrorMessage>
              </FormControl>

              <Checkbox fontSize="60%" m={0} isChecked={showPassword} onChange={() => setShowPassword(!showPassword)}>パスワードを見る</Checkbox>
            </VStack>

            <FormControl><div className="edit_form_summary">新規登録時はパスワードは必須項目です。<br />数字を含む8文字以上の半角文字を設定してください。</div></FormControl>
            </>
          ) : (
            <>
            <HStack display={isPasswordVisible ? "flex" : "none"}>
              <VStack align="flex-start">
                <FormControl isInvalid={Boolean(formErrors.password)}>
                  <FormLabel><span>パスワード</span></FormLabel>
                  <Input
                    className="edit_form_middle"
                    type={showPassword ? "text" : "password"} 
                    placeholder=""
                    autoComplete={"new-password"}
                    {...registerElement("password", 
                      {
                        pattern: {
                          value: /^(?=.*\d).{8,}$/,
                          message: "パスワードは数字を含む8文字以上の半角文字を設定してください。",
                        },
                      }
                    )} />
                  <FormErrorMessage>{ formErrors.password?.message }</FormErrorMessage>
                </FormControl>
                <Checkbox fontSize="60%" m={0} isChecked={showPassword} onChange={() => setShowPassword(!showPassword)}>パスワードを見る</Checkbox>
              </VStack>
              <FormControl >
                <div className="edit_form_summary">新しいパスワードを入力してください。<br />数字を含む8文字以上の半角文字を設定してください。</div>
              </FormControl>
            </HStack>
            <HStack display={isPasswordVisible ? "none" : "flex"}>
              <FormControl>
                <Button onClick={togglePasswordVisibility}>パスワードの変更</Button>
              </FormControl>
              <FormControl>
                <div className="edit_form_summary">パスワードを変更する際に、このボタンをクリックしてください。</div>
              </FormControl>
            </HStack>
            </>
          )
        }
        </HStack>

      <Divider />

      <HStack>

        <FormControl isInvalid={ Boolean(formErrors.status) }>
          <FormLabel><span>ステータス</span></FormLabel>
          <Select
            className="edit_form_select"
            defaultValue="teaching" 
            {...registerElement("status", {
              onChange: handleStatusChange, // onChangeイベントをフック
            })}
            >
            {/* todo: ループで記述 */}
            <option key={"teaching"} value={"teaching"}>{teacherStatus("teaching")}</option>
            <option key={"sabbatical"} value={"sabbatical"}>{teacherStatus("sabbatical")}</option>
          </Select>
          <FormErrorMessage>{ formErrors.status?.message }</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={ Boolean(formErrors.expiredate) }>
          <FormLabel><span>有効期限</span></FormLabel>

          <DatePicker 
            selected={expirationDate}
            onChange={(expirationDate: Date) => {
              setExpirationDate(expirationDate);
            }}
            selectsEnd
            placeholderText="未設定"
            customInput={React.createElement(forwardRef<HTMLInputElement, InputProps>((props, ref) => (<Input width="340px" height="50px" fontSize="lg" ref={ref} {...props}/>)))}
            showTimeSelect
            dateFormat="yyyy-MM-dd HH:mm:ss"
            popperPlacement="right"
            timeFormat="HH:mm"
            strictParsing={true}
          />
          <FormErrorMessage>{ formErrors.expiredate?.message }</FormErrorMessage>
        </FormControl>

        <FormControl >
          <div className="edit_form_summary">
            有効期限が設定されている場合、有効期限を過ぎるとログインできなくなります。
          </div>
        </FormControl>
      </HStack>

      <Divider />

      <HStack>
        <FormControl isInvalid={ Boolean(formErrors.familyName) } isRequired>
          <FormLabel 
            requiredIndicator = {
            <span style={{ color: "white", fontSize: "70%", backgroundColor:"#df6694", marginLeft: "4px",}}>✱必須項目</span>
            }>
              <span>姓</span>
          </FormLabel>
          <Input className="edit_form_middle" {...registerElement("familyName", {
            required: "姓は必須項目です。"
          })} />
          <FormErrorMessage>{ formErrors.familyName?.message }</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={ Boolean(formErrors.name) }>
          <FormLabel><span>名</span></FormLabel>
          <Input className="edit_form_middle" {...registerElement("name", {})} />
          <FormErrorMessage>{ formErrors.name?.message }</FormErrorMessage>
        </FormControl>

        <FormControl >
          <div className="edit_form_summary">
            姓は必須項目です。
         </div>
        </FormControl>

      </HStack>

      <HStack>
        <FormControl isInvalid={ Boolean(formErrors.familyNamePronunciation) }>
          <FormLabel><span>姓（かな）</span></FormLabel>
          <Input className="edit_form_middle" {...registerElement("familyNamePronunciation", {})} />
          <FormErrorMessage>{ formErrors.familyNamePronunciation?.message }</FormErrorMessage>
        </FormControl>
        <FormControl isInvalid={ Boolean(formErrors.namePronunciation) }>
          <FormLabel><span>名（かな）</span></FormLabel>
          <Input className="edit_form_middle" {...registerElement("namePronunciation", {})} />
          <FormErrorMessage>{ formErrors.namePronunciation?.message }</FormErrorMessage>
        </FormControl>
      </HStack>

      <FormControl width="100%">
        
        <FormLabel><span>誕生日</span></FormLabel>      
        <DatePicker
          selected={birthday}
          onChange={(birthday: Date) => {
            setBirthday(birthday);
          }}
          placeholderText="未設定"
          customInput={React.createElement(forwardRef<HTMLInputElement, InputProps>((props, ref) => (<Input width="260px" height="50px" fontSize="lg" ref={ref} {...props}/>)))}
          strictParsing={true} // 全部入力した後で確定する。やや不具合あり // customInput lost the focus after entering one or max 2 characters · Issue #2051 · Hacker0x01/react-datepicker https://github.com/Hacker0x01/react-datepicker/issues/2051
          dateFormat="yyyy-MM-dd"
          popperPlacement="right"
          // openToDate={new Date("2000-01-01")}
          showYearDropdown
          minDate={new Date("1900-01-01")}
          maxDate={new Date()}
          yearDropdownItemNumber={100}
          showMonthDropdown
        />
      </FormControl>

      <Divider />

      <HStack>
        <FormControl isInvalid={ Boolean(formErrors.postalNumber) }>
          <FormLabel><span>郵便番号</span></FormLabel>
          <Input className="edit_form_short" 
            type="number"
            {...registerElement("postalNumber", 
              {
                pattern: {
                  value: /^\d{7}$/,
                  message: "郵便番号はハイフン'-'無し半角数字7桁で入力してください。",
                },
              }
            )} />

          <FormErrorMessage>{ formErrors.postalNumber?.message }</FormErrorMessage>
        </FormControl>
        <FormControl >
          <div className="edit_form_summary">
            郵便番号はハイフン'-'無し半角数字7桁で入力してください。<br />
            例）1020074
        </div>
        </FormControl>
      </HStack>

      <HStack>
        <FormControl isInvalid={ Boolean(formErrors.address1) }>
          <FormLabel><span>住所１</span></FormLabel>
          <Input className="edit_form_long" {...registerElement("address1", {})} />
          <FormErrorMessage>{ formErrors.address1?.message }</FormErrorMessage>
        </FormControl>
        <FormControl >
          <div className="edit_form_summary">
            都道府県・市区町村・町域・番地で入力してください。<br />
            例）東京都千代田区九段南1-5-6
          </div>
        </FormControl>
      </HStack>

      <HStack>
        <FormControl isInvalid={ Boolean(formErrors.address2) }>
          <FormLabel><span>住所２</span></FormLabel>
          <Input className="edit_form_long" {...registerElement("address2", {})} />
          <FormErrorMessage>{ formErrors.address2?.message }</FormErrorMessage>
        </FormControl>
        <FormControl >
          <div className="edit_form_summary">
            建物名・マンション名・部屋番号等を入力してください。<br />
            例）りそな九段ビル5F
          </div>
        </FormControl>
      </HStack>

      <HStack>
        <FormControl isInvalid={ Boolean(formErrors.phoneNumber) }>
          <FormLabel><span>電話番号</span></FormLabel>
          <Input className="edit_form_middle"
          type="string"
          {...registerElement("phoneNumber", 
            {
              pattern: {
                value: /^\(?\d{1,4}\)?-?\(?\d{1,4}-?\)?\d{4}$/,
                message: "電話番号を半角文字で入力してください。",
              },
            }
          )} />
          <FormErrorMessage>{ formErrors.phoneNumber?.message }</FormErrorMessage>
        </FormControl>
        <FormControl >
          <div className="edit_form_summary">
            電話番号を半角文字で入力してください。<br />
            例）03-6869-2414
          </div>
        </FormControl>
      </HStack>

      <HStack>
        <FormControl isInvalid={ Boolean(formErrors.email) }>
          <FormLabel><span>メールアドレス</span></FormLabel>
          <Input className="edit_form_long" 
            {...registerElement("email", {
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "メールアドレスを半角文字で入力してください。",
              },
            }
          )} 
          />
          <FormErrorMessage>{ formErrors.email?.message }</FormErrorMessage>
        </FormControl>
        <FormControl >
          <div className="edit_form_summary">
            メールアドレスを半角文字で入力してください。<br />
            例）info@yuber.jp
          </div>
        </FormControl>
      </HStack>

      <FormControl isInvalid={Boolean(formErrors.note)}>
        <FormLabel><span>備考</span></FormLabel>
        <Textarea size="lg" {...registerElement("note") } />
        <FormErrorMessage>{ formErrors.note?.message }</FormErrorMessage>
      </FormControl>

      <Modal isOpen={isFinishOpen} onClose={onFinishClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>保存</ModalHeader>
          <ModalCloseButton />
          <ModalBody>先生情報を保存しました。</ModalBody>
          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={handleOk}>OK</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    
      <Modal isOpen={isErrorOpen} onClose={onErrorClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Error</ModalHeader>
          <ModalCloseButton />
          <ModalBody>{formError}</ModalBody>
          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onErrorClose}>OK</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      </VStack>
    </PageBody>
  </Page>
}
